import React, { Dispatch, SetStateAction, useState } from 'react';

import { AddressVerificationResponse } from './addressVerificationTypes';
import { VERIFIED_ADDRESS } from './constants';
import buildAddresses from './utilities/buildAddresses';
import buildModalButtons from './utilities/buildModalButtons';
import buildModalTitle from './utilities/buildModalTitle';

function Modal(props: {
  handleSubmitClick: (addressTypeToSubmit: string) => void;
  addressVerificationResponse: AddressVerificationResponse;
  setShowAddressVerification: Dispatch<SetStateAction<boolean>>;
}) {
  const { addressVerificationResponse, setShowAddressVerification, handleSubmitClick } = props;
  const { modalType } = addressVerificationResponse;
  const [addressSelected, setAddressSelected] = useState(VERIFIED_ADDRESS);

  return (
    <>
      <section className="av">
        <div className="av__overlay" />
        <div className="av__body">
          {buildModalTitle(modalType)}
          {buildAddresses(
            modalType,
            setAddressSelected,
            addressSelected,
            addressVerificationResponse,
            setShowAddressVerification,
          )}
          {buildModalButtons(
            modalType,
            setShowAddressVerification,
            handleSubmitClick,
            addressSelected,
          )}
        </div>
      </section>
    </>
  );
}

export default Modal;
